import { AfterViewInit, Component, ElementRef, EventEmitter, Inject, Input, OnChanges, OnInit, Output, PLATFORM_ID, SimpleChanges, ViewChild } from '@angular/core';
import { EYesNo } from '../../../../../shared/models/types.enum';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { DateUtils } from '../../../../../shared/helpers/dateUtils';

@Component({
  selector: 'roar-details',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule
  ],
  templateUrl: './roar-details.component.html',
  styleUrl: './roar-details.component.css'
})
export class RoarDetailsComponent implements OnInit, OnChanges, AfterViewInit {

  @Input() roarAssignmentFormData: any;
  @Output() onSaveSection3 = new EventEmitter<any>();

  @ViewChild('datepickerCompletionDate') datepickerCompletionDate!: ElementRef;
  
  yesNo = EYesNo;
  roarDetailsForm: FormGroup = new FormGroup([]);
  questionList = [
    {
      question: "Duration: *",
      formControlName: "duration",
      type: "text"
    },
    {
      question: "Frequency: *",
      formControlName: "frequency",
      type: "text"
    },
    {
      question: "How will you know if the intervention is successful? *",
      formControlName: "intervention_success",
      type: "text"
    },
    {
      question: "Planning Notes: *",
      formControlName: "planning_notes",
      type: "textarea"
    },
  ]

  constructor(
    @Inject(PLATFORM_ID) private platformId: object
  ) {}

  ngOnInit() {
    this.initializeForm();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['roarAssignmentFormData'] && this.roarAssignmentFormData) {
      this.initializeForm();
    }
  }

  private initializeForm() {
    const group: any = {};
    
    this.questionList.forEach(question => {
      group[question.formControlName] = new FormControl(this.roarAssignmentFormData?.[question.formControlName] || '', Validators.required);
    });
    
    group['completion_date'] = new FormControl(this.roarAssignmentFormData?.completion_date || DateUtils.formatDateForBackend(DateUtils.getCurrentFormattedDate()), Validators.required);
    group['review'] = new FormControl(this.roarAssignmentFormData && this.roarAssignmentFormData.review !== undefined ? String(this.roarAssignmentFormData.review) : this.yesNo.No, Validators.required);

    this.roarDetailsForm = new FormGroup(group);
  }  

  async ngAfterViewInit(): Promise<void> {
    if (isPlatformBrowser(this.platformId)) {
      // Dynamically import the Datepicker to avoid server-side loading
      const { Datepicker } = await import('flowbite-datepicker');
      if (this.datepickerCompletionDate) {
        new Datepicker(this.datepickerCompletionDate.nativeElement, {
          autohide: true,
          format: 'mm/dd/yyyy'
        });
        // set default value to display for incident date
        if (this.roarAssignmentFormData?.completion_date) {
          // if date_of_incident is available, set it to the datepicker
          this.datepickerCompletionDate.nativeElement.value = DateUtils.formatDateForDisplay(this.roarAssignmentFormData.completion_date);
        } else {
          // if date_of_incident is not available, set it to the current date
          this.datepickerCompletionDate.nativeElement.value = DateUtils.getCurrentFormattedDate();
        }
        this.datepickerCompletionDate.nativeElement.addEventListener('changeDate', (event: any) => {
          const formattedDate = DateUtils.formatDateForBackend(event.target.value);
          this.roarDetailsForm.get('completion_date')?.setValue(formattedDate);
        });
      }
    }
  }

  saveRoarDetails(): void {
    if (this.roarDetailsForm.valid) {
        this.onSaveSection3.emit(this.roarDetailsForm.value);
    }
  }

}
